// Site data for Robo Demo LLC

export const LOGO_URL = "/robo-demo-logo.png";

export const media = {
  heroBg: "/hero-excavator.jpg",
  servicesImg: "/services-bg.jpg",
  portfolioImg: "/portfolio-bg.jpg",
};

export const mockData = {
  company: {
    name: "Robo Demo LLC",
    tagline: "Professional Demolition & Site Work Services",
    description: "Service Disabled Veteran Owned Small Business",
    location: "Virginia"
  },
  
  services: [
    {
      id: 1,
      title: "Residential Demolition",
      description: "Complete residential demolition and renovation services for homes, garages, sheds, and other residential structures.",
      features: ["Safe & efficient demolition", "Renovation services", "Debris removal", "Site cleanup", "Permit assistance"]
    },
    {
      id: 2,
      title: "Commercial Demolition", 
      description: "Large-scale commercial building demolition with proper safety protocols, environmental compliance, and total white boxing services.",
      features: ["Industrial buildings", "Office complexes", "Retail structures", "Total white boxing", "Environmental safety"]
    },
    {
      id: 3,
      title: "Site Clearing",
      description: "Complete site preparation and land clearing services for new construction projects.",
      features: ["Land clearing", "Excavation work", "Grading services", "Utility preparation"]
    },
    {
      id: 4,
      title: "Project Management & Oversight",
      description: "Comprehensive project management and oversight services to ensure your demolition project runs smoothly from start to finish.",
      features: ["Project planning & coordination", "Timeline management", "Quality control oversight", "Regulatory compliance"]
    }
  ],

  projects: [
    {
      id: 1,
      title: "Industrial Steel Building Demolition",
      location: "1 Church Rd. York PA",
      type: "Commercial",
      description: "Complete strip out and demolition of 41,000 SF steel building with multiple kilns, deep conveyor pit removal, entire slab and foundation removal, and crushing of 25,000 tons of concrete.",
      images: [
        "/projects/p1_1.jpg",
        "/projects/p1_2.jpg",
        "/projects/p1_3.jpg",
        "/projects/p1_4.jpg"
      ]
    },
    {
      id: 2,
      title: "Project Management and Oversight of University of Maryland Powerplant Rehabilitation",
      location: "University of Maryland, College Park MD",
      type: "Project Management",
      description: "Provided project management and oversight for the comprehensive demolition of all old steam generation equipment at the University of Maryland power plant. This complex industrial project required precise coordination and oversight to ensure the safe removal of legacy powerplant infrastructure.",
      images: [
        "/projects/p2_1.jpg",
        "/projects/p2_2.jpg",
        "/projects/p2_3.jpg",
        "/projects/p2_4.jpg",
        "/projects/p2_5.jpg",
        "/projects/p2_6.jpg"
      ]
    },
    {
      id: 3,
      title: "Rhino Health USA Inc Manufacturing Line Demolition",
      location: "Fort Worth, Texas",
      type: "Project Management",
      description: "Provided project management and oversight for the specialized demolition of four COVID-era glove manufacturing lines in Fort Worth, Texas. This project required careful coordination to safely dismantle complex manufacturing equipment and production infrastructure.",
      images: [
        "/projects/p3_1.jpg",
        "/projects/p3_2.jpg",
        "/projects/p3_3.jpg",
        "/projects/p3_4.jpg",
        "/projects/p3_5.jpg"
      ]
    }
  ],

  contact: {
    phone: "(703) 278-3815",
    email: "estimating@robo-demo.com",
    serviceArea: "DMV Area (DC/MD/VA) and Nationwide"
  },

  testimonials: [
    {
      id: 1,
      name: "John Smith",
      company: "Smith Construction",
      text: "Robo Demo LLC provided excellent demolition services. Professional, safe, and on time.",
      rating: 5
    },
    {
      id: 2,
      name: "Sarah Johnson", 
      company: "Residential Client",
      text: "Outstanding work on our home demolition. Clean, efficient, and respectful of our property.",
      rating: 5
    }
  ]
};

export default mockData;